import React, { Component } from "react";
import PacDislipidemia from "./PacDislipidemia";
import PacSindMeta from "./PacSindMeta";

export default class PanelPacCronicos2 extends Component {

  render() {
    
    const {unidad_medica_user}= this.props;

    return(
      
      unidad_medica_user !== "" &&
      <div className="grid-container-fvg">
      <div className="grid-item-fvg">  
        <span className="format-titles-pnl">DISLIPIDEMIA</span>  
        <PacDislipidemia {...this.props}/>
        <div className="container-square">
          <div className="square_displidemia_pnl">
          </div>
          <span className="pnl-format-pie">Pacientes</span>  
        </div> 
      </div>
      <div className="grid-item-fvg">  
        <span className="format-titles-pnl">SÍNDROME METABÓLICO</span>  
        <PacSindMeta {...this.props}/>
        <div className="container-square">
          <div className="square_sind_metabolico_pnl">
          </div>
          <span className="pnl-format-pie">Pacientes</span>  
        </div> 
      </div>
    </div>
    );    
  }
}
